import React from 'react';
import { pointType } from '../../../constants/types/mypage-type';
import PointItem from './PointItem';
interface PointListProps {
  list: pointType[];
}
const PointListComp = ({ list }: PointListProps) => {
  return list === undefined || list.length === 0 ? (
    <section>
      <div className="flex h-[200px] items-center justify-center">
        <p className="text-[14px] text-gray5">내역이 없습니다.</p>
      </div>
    </section>
  ) : (
    <section>
      {list
        .filter((point) => Number(point.amount) !== 0) // 사용/적립액이 0점인 경우 표시 제외
        .map((point, key) => (
          <PointItem key={key} data={point} />
        ))}
    </section>
  );
};

export default PointListComp;
